import React from "react";
import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const renderPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(
        <li className={`page-item ${currentPage === i ? "active" : ""}`} key={i}>
          <Link className="page-link" to="#" onClick={() => onPageChange(i)}>
            {i}
          </Link>
        </li>
      );
    }
    return pageNumbers;
  };

  return (
    <React.Fragment>
      <Row>
        <Col lg={12} className="mt-4 mb-4 pt-2">
          <nav aria-label="Page navigation example">
            <ul className="pagination job-pagination mb-0 justify-content-center">
              <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                <Link
                  className="page-link"
                  to="#"
                  onClick={() => onPageChange(currentPage - 1)}
                >
                  <i className="mdi mdi-chevron-double-left fs-15"></i>
                </Link>
              </li>
              {renderPageNumbers()}
              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <Link
                  className="page-link"
                  to="#"
                  onClick={() => onPageChange(currentPage + 1)}
                >
                  <i className="mdi mdi-chevron-double-right fs-15"></i>
                </Link>
              </li>
            </ul>
          </nav>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Pagination;
